import React from "react";
import { Datagrid, EditButton, ShowButton, List, TextField, DeleteWithConfirmButton } from "react-admin";
import { EmptyList } from "../../../../common/components";

const ListUsers = () => {
  return (
    <List
      title="Потребители"
      sort={{ field: "id", order: "DESC" }}
      exporter={false}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Име"
          source="full_name"
          sortable={false}
        />
        <TextField
          label="E-мейл"
          source="email"
          sortable={false}
        />
        <ShowButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListUsers;
